export default __webpack_public_path__ + "media/images/backgrounds/bg-07-1920x660-63eaa33c74923a2ee43a5b5b653a5107.jpg";